// src/modules/AuthWrapper2/rpc-bridge.ts
var _rpcClient = null;
var _rpcService = null;
function configureRpc(client, service) {
	if (_rpcClient && _rpcClient !== client) console.warn("AuthWrapper2: configureRpc() called with a different rpcClient instance. Singletons may hold stale references.");
	_rpcClient = client;
	_rpcService = service;
}
function rpc() {
	if (!_rpcClient || !_rpcService) throw new Error("AuthWrapper2: configureRpc() must be called before accessing rpc(). Ensure <AuthWrapper2> is mounted inside <RPCContextProvider>.");
	return {
		rpcClient: _rpcClient,
		rpcService: _rpcService
	};
}
export { configureRpc, rpc };

//# sourceMappingURL=rpc-bridge.js.map